import React, { Component } from "react";
import ImageGallery from 'react-image-gallery';

let images = [];

class Images extends Component {

  buildImageArray() {
    var img = '001.jpg';

    for (var i = 1; i <= 20; i++) {
      img = '00' + i + '.jpg';

      if (i > 9) {
        img = '0' + i + '.jpg';
      }

      images.push({
        original: require('../images/gallery/' + img),
        thumbnail: require('../images/gallery/' + img)
      });
    }
  }

  componentDidMount() {
    this.buildImageArray();
  }

  render() {
    return (
      <div>
        <h4>Image Gallery</h4>
        <p>Demonstration of an image gallery component to view images. I did not write the gallery component itself, credit for that goes here: <a href="https://www.npmjs.com/package/react-image-gallery" target="_blank">https://www.npmjs.com/package/react-image-gallery</a></p>
        <p>The images used here however are mine from a trip to Portland, Maine and the surrounding area.</p>
        <br />
        <div className="image-gallery-cont">
          <ImageGallery autoPlay={true} showFullscreenButton={false} thumbnailPosition={"left"} items={images} />
        </div>
        <p>&nbsp;</p>
      </div>
    );
  }
}

export default Images;


// WEBPACK FOOTER //
// ./src/components/Images.js